import { Predicate } from "breadcommon";
import { createContextWithSetter } from "../utils/ContextUtils";
import { TransactionColumn } from "./TransactionColumn";

export enum SortOrders {
  Ascending,
  Descending,
}

export type ColumnSettings = {
  predicate: Predicate | null;
  shown: boolean;
};

export type TransactionsNav = {
  sortColumn: TransactionColumn;
  sortOrder: SortOrders;
  columnSettings: Record<TransactionColumn, ColumnSettings>;
  searchString: string;
  searchStringExactMatch: boolean;
};

export const defaultTransactionsNav: TransactionsNav = {
  sortColumn: TransactionColumn.DATE,
  sortOrder: SortOrders.Descending,
  columnSettings: {
    [TransactionColumn.DATE]: { predicate: null, shown: true },
    [TransactionColumn.ACCOUNT]: { predicate: null, shown: true },
    [TransactionColumn.TYPE]: { predicate: null, shown: true },
    [TransactionColumn.MERCHANT]: { predicate: null, shown: true },
    [TransactionColumn.DESCRIPTION]: { predicate: null, shown: true },
    [TransactionColumn.CATEGORY]: { predicate: null, shown: true },
    [TransactionColumn.RULE]: { predicate: null, shown: true },
    [TransactionColumn.REVIEWED]: { predicate: null, shown: true },
    [TransactionColumn.AMOUNT]: { predicate: null, shown: true },
    [TransactionColumn.ID]: { predicate: null, shown: false },
    [TransactionColumn.TAGS]: { predicate: null, shown: true },
  },
  searchString: "",
  searchStringExactMatch: false,
};

export const TransactionsNavContext =
  createContextWithSetter<TransactionsNav>(defaultTransactionsNav);
